import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ElementOverflowListenerDirective } from './element-overflow-listener.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ElementOverflowListenerDirective],
  exports: [ElementOverflowListenerDirective],
})
export class ElementOverflowListenerModule {}
